// extracted by mini-css-extract-plugin
module.exports = {"vat":"styles_vat__kom4h","vatInfo":"styles_vatInfo__qQ666"};